import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  bbrbbr: [],
  einstellungen: [],
  loading: false,
  error: null
}

// getters
const getters = {
  bbr: (state) => (id) => {
    return state.bbrbbr.find(bbr => bbr.id === id)
  },
  bbrStatus: (state) => (status) => {
    if (status === 'home') {
      return state.bbrbbr
    } else {
      let items = []
      state.bbrbbr.forEach(bbr => {
        if (bbr.status === status) {
          items.push(bbr)
        }
      })
      return items
    }
  },
  nurBbrbbr (state) {
    let bbrbbr = []
    let allowedStatus
    if (state.einstellungen.find(item => item.id === 'mitgliederstatus')) {
      allowedStatus = state.einstellungen.find(item => item.id === 'mitgliederstatus').status
        .filter(item => item.mitglied === true)
        .map(item => item.status)
    }
    if (allowedStatus) {
      state.bbrbbr.forEach(bbr => {
        if (allowedStatus.includes(bbr.status)) {
          bbrbbr.push(bbr)
        }
      })
    }
    return bbrbbr
  },
  nurBbrbbrUndVerstorben (state) {
    let bbrbbr = []
    let allowedStatus
    if (state.einstellungen.find(item => item.id === 'mitgliederstatus')) {
      allowedStatus = state.einstellungen.find(item => item.id === 'mitgliederstatus').status
        .filter(item => item.mitglied === true)
        .map(item => item.status)
    }
    if (allowedStatus) {
      state.bbrbbr.forEach(bbr => {
        if (allowedStatus.includes(bbr.status) || (bbr.status === 'Verstorben')) {
          bbrbbr.push(bbr)
        }
      })
    }
    return bbrbbr
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadBbrBbr ({commit}) {
    commit('setLoading', true)
    console.log('Bundesbrüder laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontakte').orderBy('nachname')
    .onSnapshot(snapshot => {
      const bbrbbr = []
      snapshot.forEach(doc => {
        if (!doc.data().delete) {
          bbrbbr.push({
            ...doc.data(),
            id: doc.id
          })
        }
        commit('setLoadedBbrBbr', bbrbbr)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createBbr ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontakte').add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteBbrData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontakte').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteBbr', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateBbrData ({commit, state}, payload) {
    console.log(payload)
    commit('setLoading', true)
    payload.zuletztGeaendertVon = state.bbrbbr.find(bbr => bbr.anmeldeID === firebase.auth().currentUser.uid).id
    payload.zuletztGeaendertAm = new Date().toISOString()
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('kontakte').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      // commit('updateBbr', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  loadEinstellungen ({commit}) {
    commit('setLoading', true)
    console.log('Einstellungen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('einstellungen')
    .onSnapshot(snapshot => {
      const einstellungen = []
      snapshot.forEach(doc => {
        einstellungen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedEinstellungen', einstellungen)
        commit('setLoading', false)
      })
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedBbrBbr (state, payload) {
    state.bbrbbr = payload
  },
  createBbr (state, payload) {
    state.bbrbbr.push(payload)
  },
  updateBbr (state, payload) {
    const bbr = state.bbrbbr.find(bbr => {
      return bbr.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        bbr[key] = payload[key]
      }
    })
  },
  deleteBbr (state, payload) {
    let array = state.bbrbbr
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.bbrbbr = array
  },
  setLoadedEinstellungen (state, payload) {
    state.einstellungen = payload
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bbrbbr_alt.js